import $ from 'jquery';

const BASE_DIV = 0.0625;

// Calculate panels for roll-fold brochure
function calculatePanels() {
  const totalWidth = parseFloat($('#panels_total_width').val());
  const numberOfPanels = parseInt($('#panels_number_of_panels').val());
  let panelWidth = parseFloat($('#panels_first_panel_width').val());
  let panelAdjustment;
  let firstPanelWidth; 
  const panels = [];
  let widthRemaining;
  let panelCounter = 0;
  
  if (isNaN(totalWidth) || isNaN(numberOfPanels) || totalWidth === '' || numberOfPanels === '') {
    alert('Please enter width and number of panels.');
    return false;
  }
  
  if (isNaN(panelWidth) || panelWidth === '') {
    panelWidth = totalWidth / numberOfPanels;
    console.log('+++ first panel_width: ' + panelWidth);
  }
  
  panelAdjustment = Math.round(panelWidth / BASE_DIV) * BASE_DIV;
  console.log('+++ panel_width / base_div = panel_adjustment: ' + panelWidth + ' / ' + BASE_DIV + ' = ' + panelAdjustment);
  
  if ((panelAdjustment === panelWidth) && (((numberOfPanels - 2) * BASE_DIV) >= BASE_DIV)) {
    firstPanelWidth = panelAdjustment;
  } else {
    firstPanelWidth = (panelAdjustment + BASE_DIV);
  }
  console.log('+++ first_panel_width: ' + firstPanelWidth);
  
  panels[0] = firstPanelWidth;
  widthRemaining = totalWidth - firstPanelWidth;
  
  console.log('+++ initial width_remaining: ' + widthRemaining);
  
  while (widthRemaining >= 0.125) {
    panelCounter = 0;
    widthRemaining = totalWidth - firstPanelWidth;
    console.log('+++ panel_counter: ' + panelCounter);
    console.log('+++ width_remaining: ' + widthRemaining);
    
    for (let i = 0; i < (numberOfPanels - 1); i++) {
      const nextPanel = (firstPanelWidth - (i * BASE_DIV));
      console.log('++++ i: ' + i);
      console.log('++++ i * base_div: ' + (i * BASE_DIV));
      console.log('++++ next_panel: ' + nextPanel);
      panelCounter = i + 1;
      
      if (nextPanel > widthRemaining) {
        panels[panelCounter] = widthRemaining; 
        widthRemaining = 0;
        break;
      }
      
      widthRemaining = widthRemaining - nextPanel;
      panels[panelCounter] = nextPanel;
    }
    
    if (widthRemaining >= 0.125) {
      panels[0] += 0.0625;
    }
    
    if ((widthRemaining > 0) && (widthRemaining < 0.125)) {
      const message = 'The document needs to be undertrimmed by: ' + widthRemaining;
      console.log(message);
    }
    
    firstPanelWidth = firstPanelWidth + 0.0625;
  }
  
  return panels;
}

// Display panels visually
function displayPanels(panels) {
  const totalWidth = parseFloat($('#panels_total_width').val());
  let i = 0;
  
  // Clear existing panels first
  $('.panel').width('0%').html('');
  
  while (i < panels.length) {
    console.log('==== panels[' + i + ']: ' + panels[i]);
    const panelWidth = (panels[i] / totalWidth) * 100;
    $('.panel:nth-child(' + (i + 1) + ')').width((panelWidth.toPrecision(2) - 2) + '%');
    $('.panel:nth-child(' + (i + 1) + ')').html(panels[i] + '" - ' + (panelWidth.toPrecision(2) - 1) + '%');
    i++;
  }
}

// Initialize panelizer page
export function initPanelizer() {
  $('body').off('click.panelizer', '#calculate_panels');
  $('body').on('click.panelizer', '#calculate_panels', function(e) {
    e.preventDefault();
    const results = calculatePanels();
    if (results) {
      console.log('++++++ results: ' + results);
      displayPanels(results);
    }
  });
}

// Expose to global scope
window.initPanelizer = initPanelizer;

// Auto-initialize on turbo:load
$(document).on('turbo:load', function() {
  if ($('#calculate_panels').length > 0 && $('[data-section="panelizers"]').length > 0) {
    initPanelizer();
  }
});
